<template>
  <HeaderHome :user="this.$store.state.user.prenom"/>
  <div class="exam-conduite-container">

    <!-- ===== PAGE HEADER ===== -->
    <div class="page-header">
      <div class="page-header-left">
        <h1>Examen de Conduite</h1>
        <p>Gestion des demandes d'examen élèves</p>
      </div>
      <router-link to="/agence/planning">
        <button class="btn btn-primary">
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
            <path d="M19 12H5M12 5l-7 7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Retourner au planning
        </button>
      </router-link>
    </div>

    <!-- ===== TOOLBAR ===== -->
    <div class="ec-toolbar">
      <select class="form-select" v-model="typeTable" @change="changeListe">
        <option value="eleves">Liste Élèves</option>
        <option value="exams">Liste Exam</option>
        <option value="exams blanc">Liste Exam Blanc</option>
      </select>

      <template v-if="showExamsTab === 'eleve'">
        <button
          class="btn btn-secondary"
          v-if="!showElevesSelec"
          @click="showEleves(true)"
        >
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
            <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Afficher élèves sélectionnés
        </button>
        <button
          class="btn btn-blue"
          v-if="showElevesSelec"
          @click="showEleves(false)"
        >
          <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
          </svg>
          Afficher tous les élèves
        </button>
      </template>
    </div>

    <!-- ===== TABLE LISTE ÉLÈVES ===== -->
    <div class="table-wrap" v-if="showExamsTab === 'eleve'">
      <DataTable
        :value="eleves"
        :reorderableRows="true"
        @rowReorder="onRowReorder"
        responsiveLayout="scroll"
        tableStyle="min-width: 60rem"
        :rows="10"
        @click="onSelected"
        selectionMode="single"
        v-model:selection="selectedEleve"
        class="ec-datatable"
      >
        <!-- Drag handle -->
        <Column rowReorder style="width: 40px;" />

        <!-- Supprimer -->
        <Column header="" style="width: 44px;">
          <template #body="slotProps">
            <button class="minus-btn" @click="deleteDemandeEleve(slotProps.data)" title="Supprimer">
              <svg width="12" height="12" fill="none" viewBox="0 0 24 24">
                <path d="M5 12h14" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
              </svg>
            </button>
          </template>
        </Column>

        <!-- Checkbox sélection -->
        <Column header="Selec" style="width: 56px;">
          <template #body="slotProps">
            <template v-if="showElevesSelec === true">
              <input
                class="check-custom"
                type="checkbox"
                @change="setElevesSelec(slotProps.data)"
                :name="slotProps.data.id"
                :id="slotProps.data.id"
                :value="slotProps.data.id"
                checked
              />
            </template>
            <template v-else>
              <input
                class="check-custom"
                type="checkbox"
                v-if="this.elevesSelec.find((e) => e.id == slotProps.data.id) != undefined"
                @change="setElevesSelec(slotProps.data)"
                :name="slotProps.data.id"
                :id="slotProps.data.id"
                :value="slotProps.data.id"
                checked
              />
              <input
                class="check-custom"
                type="checkbox"
                v-else
                @change="setElevesSelec(slotProps.data)"
                :name="slotProps.data.id"
                :id="slotProps.data.id"
                :value="slotProps.data.id"
              />
            </template>
          </template>
        </Column>

        <Column field="demande" header="Date Demande">
          <template #body="slotProps">
            <span class="cell-muted">{{ slotProps.data.demande }}</span>
          </template>
        </Column>

        <Column field="source" header="Source">
          <template #body="slotProps">
            <template v-if="slotProps.data.source">
              <div class="source-name">{{ slotProps.data.source }}</div>
              <div class="source-sub" v-if="slotProps.data.sourceSub">{{ slotProps.data.sourceSub }}</div>
            </template>
            <span v-else class="cell-muted">—</span>
          </template>
        </Column>

        <Column field="mono" header="Mono">
          <template #body="slotProps">
            <span v-if="slotProps.data.mono" class="badge badge-gray">{{ slotProps.data.mono }}</span>
            <span v-else class="cell-muted">—</span>
          </template>
        </Column>

        <Column field="eleve" header="Élève">
          <template #body="slotProps">
            <div class="cell-name-bold">{{ slotProps.data.eleve }}</div>
          </template>
        </Column>

        <Column field="boite" header="Boite">
          <template #body="slotProps">
            <span
              v-if="slotProps.data.boite"
              :class="['badge', slotProps.data.boite === 'BM' ? 'badge-amber' : 'badge-green']"
            >{{ slotProps.data.boite }}</span>
            <span v-else class="cell-muted">—</span>
          </template>
        </Column>

        <Column field="acc" header="Acc">
          <template #body="slotProps">
            <span v-if="slotProps.data.acc" class="badge badge-green">
              <svg width="10" height="10" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              {{ slotProps.data.acc }}
            </span>
            <span v-else class="cell-muted">—</span>
          </template>
        </Column>

        <Column field="niveau" header="Niveau">
          <template #body="slotProps">
            <template v-if="slotProps.data.niveau != null">
              <div class="level-bar-wrap">
                <div class="level-bar">
                  <div class="level-bar-fill" :style="{ width: slotProps.data.niveau + '%' }"></div>
                </div>
                <span class="level-val">{{ slotProps.data.niveau }}</span>
              </div>
            </template>
            <span v-else class="cell-muted">—</span>
          </template>
        </Column>

        <Column field="hRestant" header="H à prog">
          <template #body="slotProps">
            <span class="cell-bold">{{ slotProps.data.hRestant }}</span>
          </template>
        </Column>

        <Column field="lastApProg" header="Dernier cours resa">
          <template #body="slotProps">
            <span class="cell-muted">{{ slotProps.data.lastApProg ?? '—' }}</span>
          </template>
        </Column>

        <Column field="solde" header="Solde">
          <template #body="slotProps">
            <span
              class="solde-val"
              :class="slotProps.data.solde > 0 ? 'solde-pos' : slotProps.data.solde < 0 ? 'solde-neg' : 'solde-zero'"
            >
              {{ slotProps.data.solde }}
            </span>
          </template>
        </Column>

        <Column field="eb" header="EB">
          <template #body="slotProps">
            <span
              v-if="slotProps.data.eb"
              :class="['eb-tag', slotProps.data.eb === 'En Attente' ? 'eb-pending' : slotProps.data.eb === 'Ok' ? 'eb-ok' : 'eb-fail']"
            >{{ slotProps.data.eb }}</span>
            <span v-else class="badge badge-gray">—</span>
          </template>
        </Column>

        <Column field="echec" header="Échec">
          <template #body="slotProps">
            <span :class="['badge', slotProps.data.echec ? 'badge-red' : 'badge-gray']">
              {{ slotProps.data.echec ? 'Oui' : 'Non' }}
            </span>
          </template>
        </Column>

        <Column field="commentaire" header="Commentaire">
          <template #body="slotProps">
            <span
              v-if="slotProps.data.commentaire !== null"
              class="commentaire-cell"
              :title="slotProps.data.commentaire"
            >
              {{ slotProps.data.commentaire.substring(0, 10) }}…
            </span>
            <span v-else class="cell-muted">—</span>
          </template>
        </Column>
      </DataTable>

      <Paginator :rows="10" :totalRecords="countEleves" @page="onPaginate" class="ec-paginator" />
    </div>

    <!-- ===== TABLE LISTE EXAMENS ===== -->
    <div v-else-if="showExamsTab === 'exam'">
      <label for="oldExam" v-if="showElevesSelec === false"><input type="checkbox" name="oldExam" id="oldExam" v-model="oldOrNew" @change="showOldOrNot">Ancien Examen</label>

      <!-- Vue liste des sessions d'exam -->
      <template v-if="showElevesSelec === false">
        <div class="table-wrap">
          <DataTable
            :value="exams"
            responsiveLayout="scroll"
            tableStyle="min-width: 30rem"
            :rows="10"
            @click="onSelectedExam"
            selectionMode="single"
            v-model:selection="selectedEleve"
            class="ec-datatable"
          >
            <Column field="date" header="Date">
              <template #body="slotProps">
                <span class="cell-muted">{{ slotProps.data.date }}</span>
              </template>
            </Column>
            <Column field="heure" header="Heure">
              <template #body="slotProps">
                <span class="badge badge-blue">{{ slotProps.data.heure }}</span>
              </template>
            </Column>
            <Column field="lieu" header="Lieu">
              <template #body="slotProps">
                <span class="cell-bold">{{ slotProps.data.lieu }}</span>
              </template>
            </Column>
            <Column field="boite" header="Boite">
              <template #body="slotProps">
                <span :class="['badge', slotProps.data.boite === 'BM' ? 'badge-amber' : 'badge-green']">
                  {{ slotProps.data.boite }}
                </span>
              </template>
            </Column>
            <Column field="nbPlace" header="Nombre de places">
              <template #body="slotProps">
                <span class="places-pill">{{ slotProps.data.nbPlace }} places</span>
              </template>
            </Column>
          </DataTable>
          <Paginator :rows="10" :totalRecords="countExams" @page="onPaginateExam" class="ec-paginator" />
        </div>
      </template>

      <!-- Vue détail d'un examen sélectionné -->
      <template v-else>
        <!-- Info card de la session -->
        <div class="exam-info-card">
          <div class="left-info">
            <div class="exam-info-pill">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/><path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
              {{ selectedEleve.date }}
            </div>
            <div class="exam-info-pill">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 7v5l3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
              {{ selectedEleve.heure }}
            </div>
            <div class="exam-info-pill">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2"/></svg>
              {{ selectedEleve.lieu }}
            </div>
            <div class="exam-info-pill exam-info-pill--boite">
              {{ selectedEleve.boite }}
            </div>
          </div>

          <button class="btn btn-secondary btn-sm" @click="closeExamSelec">
            <svg width="12" height="12" fill="none" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            Fermer
          </button>
        </div>

        <!-- Tableau des élèves de cette session -->
        <div class="table-wrap">
          <DataTable
            :value="selectedEleve.eleves"
            responsiveLayout="scroll"
            tableStyle="min-width: 30rem"
            :rows="10"
            class="ec-datatable"
          >
            <Column field="eleve" header="Élève">
              <template #body="slotProps">
                <span class="cell-name-bold">{{ slotProps.data.eleve }}</span>
              </template>
            </Column>
            <Column field="source" header="Source">
              <template #body="slotProps">
                <span class="cell-muted">{{ slotProps.data.source }}</span>
              </template>
            </Column>
            <Column field="aac" header="AAC">
              <template #body="slotProps">
                <span v-if="slotProps.data.aac" class="badge badge-green">✓</span>
                <span v-else class="badge badge-gray">—</span>
              </template>
            </Column>
            <Column field="hRestant" header="H Restant">
              <template #body="slotProps">
                <span class="cell-bold">{{ slotProps.data.hRestant }}</span>
              </template>
            </Column>
            <Column field="solde" header="Solde">
              <template #body="slotProps">
                <span
                  class="solde-val"
                  :class="slotProps.data.solde > 0 ? 'solde-pos' : slotProps.data.solde < 0 ? 'solde-neg' : 'solde-zero'"
                >{{ slotProps.data.solde }}</span>
              </template>
            </Column>
            <Column field="resultat" header="Résultat">
              <template #body="slotProps">
                <template v-if="slotProps.data.cancel !== null">
                  <span class="resultat-badge resultat-cancel">Annulé</span>
                </template>
                <template v-else>
                  <template v-if="slotProps.data.score === null">
                    <span class="resultat-badge resultat-pending">En attente</span>
                  </template>
                  <template v-else>
                    <template v-if="slotProps.data.score < 20 || slotProps.data.elim === true">
                      <span class="resultat-badge resultat-fail">Échec</span>
                    </template>
                    <template v-else>
                      <span class="resultat-badge resultat-ok">Réussi</span>
                    </template>
                  </template>
                </template>
              </template>
            </Column>
          </DataTable>
        </div>
      </template>
    </div>

    <!-- Dialog HeureaProg -->
    <Dialog v-model:visible="showAddToExam" modal header="Ajouter un examen" :style="{ width: '50%' }">
      <HeureaProg @putSelectEleve="setEleveHeader" />
    </Dialog>

  </div>
</template>

<script>

import HeureaProg from "@/components/agence/planning/split/HeureaProg.vue";
import HeaderHome from "../../components/home/HeaderHome.vue";

export default {
  props: [],

  components: {
    HeureaProg,
    HeaderHome
  },

  data() {
    return {
      eleves: [],
      elevesSelec: [],
      countEleves: 0,
      showElevesSelec: false,
      showAddToExam: false,
      showValBtn: false,
      typeTable: "eleves",
      exams: [],
      countExams: 0,
      showExamsTab: false,
      eleveExamSelec: false,
      selectedEleve: null,
      oldOrNew : false
    };
  },

  mounted() {
    this.getElevesDemandeExam(0);
  },

  methods: {
    onSelectedExam() {
      this.showElevesSelec = true;
    },

    showOldOrNot(){
      if(this.typeTable === "exams"){
        this.getExams(0, this.oldOrNew);
      }else if(this.typeTable === "exams blanc"){
        this.getExamsBlanc(0, this.oldOrNew);
      }
      
    },

    changeListe(e) {
      if (e.target.value === "eleves") {
        this.showElevesTab();
      } else if (e.target.value === "exams") {
        this.showExams();
      } else if (e.target.value === "exams blanc") {
        this.getExamsBlanc(0, this.oldOrNew);
      }
    },

    showExams() { this.getExams(0, false); this.oldOrNew = false; },
    showElevesTab() { this.getElevesDemandeExam(0); },

    getExams(offset, showOld) {
      window.api
        .get("/exams/agence/" + this.$store.state.user.agence.id + "/" + offset + "/" + showOld, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.exams = response.data.exams;
          this.countExams = response.data.count;
          this.eleves = [];
          this.countEleves = 0;
          this.showExamsTab = "exam";
        })
        .catch((error) => { console.log(error); });
    },

    getExamsBlanc(offset, showOld) {
      window.api
        .get("/examsblanc/agence/" + this.$store.state.user.agence.id + "/" + offset + "/" + showOld, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.exams = response.data.exams;
          this.countExams = response.data.count;
          this.eleves = [];
          this.countEleves = 0;
          this.showExamsTab = "exam";
        })
        .catch((error) => { console.log(error); });
    },

    getElevesDemandeExam(offset, merge = false) {
      window.api
        .get("/demande/exam/eleves/" + this.$store.state.user.agence.id + "/" + offset, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.eleves = response.data.examenDemande;
          this.countEleves = response.data.count;
          const pageSelec = response.data.examenDemande.filter(e => e.selected === true);
          if (merge) {
            pageSelec.forEach(eleve => {
              if (!this.elevesSelec.find(e => e.id === eleve.id)) {
                this.elevesSelec.push(eleve);
              }
            });
          } else {
            this.elevesSelec = pageSelec;
          }
          this.showElevesSelec = false;
          this.exams = [];
          this.countExams = 0;
          this.showExamsTab = "eleve";
        })
        .catch((error) => { console.log(error); });
    },

    getShortListElevesDemandeExam(offset) {
      window.api
        .get("/shortlist/demande/exam/eleves/" + this.$store.state.user.agence.id + "/" + offset, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.eleves = response.data.examenDemande;
          this.countEleves = response.data.count;
          this.showElevesSelec = true;
        })
        .catch((error) => { console.log(error); });
    },

    onPaginate(e) { this.getElevesDemandeExam(e.first, true); },
    onPaginateExam(e) { 
      if(this.typeTable === "exams"){
        this.getExams(e.first, this.oldOrNew); 
      }else if(this.typeTable === "exams blanc"){
        this.getExamsBlanc(e.first, this.oldOrNew); 
      }
      
    },

    onRowReorder(event) {
      this.eleves = event.value;
      if (this.showElevesSelec) {
        window.api
          .post("/set/shotlist/exam/" + this.$store.state.user.id,
            { eleves: this.eleves.map(u => u.id) },
            { headers: { Authorization: "Bearer " + this.$store.state.token } }
          )
          .then(() => {}).catch((error) => { console.log(error); });
      }
    },

    setElevesSelec(eleve) {
      let cbxEleve = document.getElementById(eleve.id);
      if (cbxEleve.checked) {
        this.elevesSelec.push(eleve);
      } else {
        this.elevesSelec = this.elevesSelec.filter((e) => e.id != eleve.id);
        if (this.showElevesSelec) this.eleves = this.elevesSelec;
      }
      window.api
        .post("/set/shotlist/exam/" + this.$store.state.user.id,
          { eleves: this.elevesSelec.map(u => u.id) },
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .then(() => {}).catch((error) => { console.log(error); });
    },

    showEleves(show) {
      if (show) {
        this.eleves = this.elevesSelec;
        this.showElevesSelec = true;
        this.getShortListElevesDemandeExam(0);
      } else {
        this.getElevesDemandeExam(0);
      }
    },

    showDialogAddExam() { this.showAddToExam = true; },

    deleteDemandeEleve(eleve) {
      let dateDemande = new Date("1111-11-11T00:00:00");
      window.api
        .patch("/exam_info_eleves/" + eleve.idd,
          { demande: dateDemande },
          { headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" } }
        )
        .then(() => {}).catch((error) => { console.log(error); });
    },

    closeExamSelec() {
      this.showElevesSelec = false;
      this.selectedEleve = null;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display&display=swap');

/* ===================== VARIABLES ===================== */
*, *::before, *::after { box-sizing: border-box; }

.exam-conduite-container {
  --green:        #1a9e6e;
  --green-light:  #e8f7f1;
  --green-mid:    #c3ead9;
  --amber:        #f59e0b;
  --amber-light:  #fef3c7;
  --blue:         #3b82f6;
  --blue-dark:    #2563eb;
  --blue-light:   #eff6ff;
  --purple:       #8b5cf6;
  --purple-light: #f5f3ff;
  --red:          #ef4444;
  --red-light:    #fee2e2;
  --text:         #1a1f2e;
  --text-2:       #64748b;
  --text-3:       #94a3b8;
  --bg:           #f4f6f9;
  --card:         #ffffff;
  --border:       #e2e8f0;
  --radius:       16px;
  --shadow-sm:    0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);

  color: var(--text);
  background: var(--bg);
  padding: 32px;
  min-height: 100vh;
  padding-top: 2rem;
}

/* ===================== PAGE HEADER ===================== */
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
  flex-wrap: wrap;
  width: 70%;
  margin: auto;
  margin: auto;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 26px;
  font-weight: 400;
  color: var(--text);
  letter-spacing: -.4px;
  margin-bottom: 2px;
  text-align: left;
  font-weight: bold;
}

.page-header p {
  font-size: 13px;
  color: var(--text-2);
}

/* ===================== BOUTONS ===================== */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all .15s;
  white-space: nowrap;
  text-decoration: none;
}
.btn-sm { padding: 5px 11px; font-size: 11px; border-radius: 8px; }

.btn-primary {
  background: var(--blue);
  color: #fff;
}
.btn-primary:hover { background: var(--blue-dark); transform: translateY(-1px); box-shadow: 0 4px 12px rgba(59,130,246,.3); }

.btn-secondary {
  background: var(--bg);
  color: var(--text-2);
  border: 1px solid var(--border);
}
.btn-secondary:hover { background: #fff; color: var(--text); border-color: var(--text-3); }

.btn-blue {
  background: var(--blue-light);
  color: var(--blue-dark);
  border: 1px solid #bfdbfe;
}
.btn-blue:hover { background: #dbeafe; }

/* ===================== TOOLBAR ===================== */
.ec-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  width: 70%;
  margin: auto;
  margin-bottom: 2rem;
}

.form-select {
  padding: 9px 32px 9px 12px;
  border: 1px solid var(--border);
  border-radius: 10px;
  font-size: 13px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  color: var(--text);
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
}
.form-select:focus { border-color: var(--blue); }

/* ===================== TABLE WRAP ===================== */
.table-wrap {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  margin-bottom: 24px;
  width: 70%;
  margin: auto;
}

/* Override PrimeVue DataTable */
.exam-conduite-container :deep(.ec-datatable .p-datatable-thead > tr > th) {
  padding: 11px 14px;
  text-align: left;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--text-3);
  background: var(--bg);
  border-bottom: 1px solid var(--border);
  border-right: none;
}

.exam-conduite-container :deep(.ec-datatable .p-datatable-tbody > tr) {
  border-bottom: 1px solid var(--border);
  transition: background .1s;
  cursor: pointer;
}
.exam-conduite-container :deep(.ec-datatable .p-datatable-tbody > tr:last-child) { border-bottom: none; }
.exam-conduite-container :deep(.ec-datatable .p-datatable-tbody > tr:hover) { background: #f8fafc !important; }
.exam-conduite-container :deep(.ec-datatable .p-datatable-tbody > tr.p-highlight) { background: #eff6ff !important; }

.exam-conduite-container :deep(.ec-datatable .p-datatable-tbody > tr > td) {
  padding: 12px 14px;
  font-size: 13px;
  color: var(--text);
  border-right: none;
  border-bottom: none;
  vertical-align: middle;
}

/* ===================== CELLULES ===================== */
.cell-muted   { color: var(--text-2); font-size: 12px; }
.cell-bold    { font-weight: 700; color: var(--text); }
.cell-name-bold { font-weight: 700; font-size: 13px; color: var(--text); }

.source-name { font-size: 12px; font-weight: 600; color: var(--text); }
.source-sub  { font-size: 11px; color: var(--text-3); }

/* ===================== BADGES ===================== */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}
.badge-gray   { background: #f1f5f9;          color: var(--text-2); }
.badge-blue   { background: var(--blue-light); color: #1d4ed8; }
.badge-green  { background: var(--green-light); color: #065f46; }
.badge-amber  { background: var(--amber-light); color: #b45309; }
.badge-red    { background: var(--red-light);   color: #b91c1c; }

/* ===================== BOUTON MINUS ===================== */
.minus-btn {
  width: 26px; height: 26px;
  border-radius: 7px;
  border: none;
  background: var(--red);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .12s;
  flex-shrink: 0;
}
.minus-btn:hover { background: #dc2626; transform: scale(1.08); }

/* ===================== CHECKBOX ===================== */
.check-custom {
  width: 16px; height: 16px;
  border: 2px solid var(--border);
  border-radius: 4px;
  cursor: pointer;
  accent-color: var(--blue);
}

/* ===================== BARRE DE NIVEAU ===================== */
.level-bar-wrap { display: flex; align-items: center; gap: 8px; }
.level-bar {
  height: 6px;
  width: 60px;
  background: var(--border);
  border-radius: 3px;
  overflow: hidden;
}
.level-bar-fill {
  height: 100%;
  border-radius: 3px;
  background: var(--blue);
}
.level-val { font-size: 12px; font-weight: 600; color: var(--text-2); }

/* ===================== EB TAG ===================== */
.eb-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}
.eb-pending { background: var(--amber-light); color: #b45309; }
.eb-ok      { background: var(--green-light); color: #065f46; }
.eb-fail    { background: var(--red-light);   color: #b91c1c; }

/* ===================== SOLDE ===================== */
.solde-val  { font-weight: 700; font-size: 13px; }
.solde-pos  { color: var(--green); }
.solde-neg  { color: var(--red); }
.solde-zero { color: var(--text-3); }

/* ===================== RÉSULTAT BADGE ===================== */
.resultat-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .02em;
}
.resultat-ok      { background: var(--green-light); color: #065f46; }
.resultat-fail    { background: var(--red-light);   color: #b91c1c; }
.resultat-pending { background: var(--amber-light); color: #b45309; }
.resultat-cancel  { background: #f1f5f9;            color: var(--text-2); }

/* ===================== COMMENTAIRE ===================== */
.commentaire-cell {
  font-size: 12px;
  color: var(--text-2);
  cursor: help;
  border-bottom: 1px dashed var(--border);
}

/* ===================== PLACES PILL ===================== */
.places-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  background: var(--purple-light);
  color: var(--purple);
}

/* ===================== EXAM INFO CARD ===================== */
.exam-info-card {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px 20px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-sm);
  width: 70%;
  margin: auto;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.left-info{
  display: flex;
  gap: 20px;
}

.exam-info-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  background: var(--blue-light);
  color: #1d4ed8;
}

.exam-info-pill--boite {
  background: var(--amber-light);
  color: #b45309;
}

/* ===================== PAGINATION PrimeVue ===================== */
.exam-conduite-container :deep(.ec-paginator) {
  border-top: 1px solid var(--border);
  background: transparent;
  padding: 12px 14px;
  font-size: 13px;
}
.exam-conduite-container :deep(.ec-paginator .p-paginator-element) {
  border-radius: 8px;
  min-width: 30px;
  height: 30px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-2);
  border: none;
  background: none;
  transition: all .12s;
}
.exam-conduite-container :deep(.ec-paginator .p-paginator-element:hover) { background: var(--bg); color: var(--text); }
.exam-conduite-container :deep(.ec-paginator .p-paginator-element.p-highlight) {
  background: var(--blue);
  color: #fff;
  font-weight: 700;
}

/* ===================== RESPONSIVE ===================== */
@media (max-width: 900px) {
  .exam-conduite-container {
    padding: 16px;
  }

  .page-header,
  .ec-toolbar,
  .table-wrap,
  .exam-info-card {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  .table-wrap {
    border-radius: 0;
    border-left: none;
    border-right: none;
    overflow-x: auto;
  }

  .exam-info-card {
    flex-direction: column;
    align-items: flex-start;
    border-radius: var(--radius);
    margin-bottom: 1rem;
  }

  .left-info {
    flex-wrap: wrap;
    gap: 8px;
  }
}

@media (max-width: 640px) {
  .ec-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .form-select {
    width: 100%;
  }

  .page-header {
    flex-direction: column;
    gap: 12px;
  }

  .page-header h1 {
    font-size: 20px;
  }
}
</style>